import React from "react";
import { Award, Star, Heart, Trophy, Medal, Crown, Sparkles, Gem, Flame, Shield, Leaf, Smile } from "lucide-react";

// Íconos disponibles para las insignias (deben coincidir con BADGE_ICONS en el backend).
export const BADGE_ICONS: Record<string, React.ComponentType<any>> = {
  award: Award, star: Star, heart: Heart, trophy: Trophy, medal: Medal, crown: Crown,
  sparkles: Sparkles, gem: Gem, flame: Flame, shield: Shield, leaf: Leaf, smile: Smile,
};

export function BadgeIcon({ icon, size = "md", muted }: { icon?: string; size?: "sm" | "md" | "lg"; muted?: boolean }) {
  const Icon = BADGE_ICONS[icon || "award"] || Award;
  const box = size === "lg" ? "w-14 h-14" : size === "sm" ? "w-8 h-8" : "w-11 h-11";
  const glyph = size === "lg" ? "w-7 h-7" : size === "sm" ? "w-4 h-4" : "w-5 h-5";
  return (
    <span className={`${box} rounded-full inline-flex items-center justify-center shrink-0 ${muted ? "bg-slate-200 text-slate-500" : "bg-gold/15 text-gold-ink"}`}>
      <Icon className={glyph} aria-hidden="true" />
    </span>
  );
}
